import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import SideMenu from '../calendrier/SideMenu';
import MenuToggleButton from '../calendrier/MenuToggleButton';
import './MainLayout.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const MainLayout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleToggleMenu = () => {
    setIsMenuOpen(prev => !prev);
  };

  const handleLogout = () => {
    localStorage.clear();
    toast.info('Déconnexion réussie');
    setTimeout(() => {
      navigate('/login');
      window.location.reload();
    }, 1000);
  };

  // Session timeout : 2 minutes (120000 ms)
  useEffect(() => {
    let timeout;

    const logoutAfterInactivity = () => {
      toast.warning('Session expirée. Vous avez été déconnecté.');
      handleLogout();
    };

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(logoutAfterInactivity, 1200000); // 20 minutes
    };
    

    resetTimer();

    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    events.forEach(event => window.addEventListener(event, resetTimer));

    return () => {
      clearTimeout(timeout);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, []);

  return (
    <div className="main-layout">
      <SideMenu isOpen={isMenuOpen} onClose={handleToggleMenu} />
      <div className="main-content">
        <div className="toolbar">
          <MenuToggleButton onClick={handleToggleMenu} />

          <div className="marquee-container">
            <div className="marquee">
              <span>Système de gestion des évènements de Jacque AKA</span>
            </div>
          </div>

          <FontAwesomeIcon
            icon={faSignOutAlt}
            className="logout-icon"
            onClick={handleLogout}
            title="Se déconnecter"
          />
        </div>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
        />

        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
